import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWarning } from "@fortawesome/free-solid-svg-icons";
import "./CaseDetails.css";
import TableComponent from "../../components/TableComponent";
import { useNavigate } from "react-router";

function CaseDetails(props) {
  const columns = [
    { name: "إسم الحالة", key: "title" },
    { name: "نوع العملية", key: "status" },
    { name: "تاريخ البدء", key: "dateoflaunch" },
    { name: " آلية التسويق", key: "marketingmethod" },
    { name: "قيمة الحالة", key: "total" },
    { name: "التحصيلات", key: "amount" },
    { name: "", key: "actions" },
  ];

  const [rows, setRows] = useState([]);
  const navigate = useNavigate();

  const dropdownOptions = [
    { label: "طلب تصميم", route: "/senddesignrequestshop/:id" },
    { label: "طلب إدارة", route: "/sendmarketingrequestshop/:id" },
    { label: "عرض التبرعات", route: "/viewdonations/:id" },
    { label: "عرض الحالة", route: "/casedetailschart/:id" },
    { label: "بيانات الحالة", route: "/casedata/:id" },
    {
      label: "سند صرف",
      action: (id, record) => {
        if (record.status == 1) {
          alert("لا يمكن اجراء اي حركات نقدية على الحالة  بعد اكتمالها ");
        } else {
          navigate(`/paymentvoucher/${id}`);
        }
      },
    },
    {
      label: "سند قبض",
      action: (id, record) => {
        if (record.status == 1) {
          alert("لا يمكن اجراء اي حركات نقدية على الحالة  بعد اكتمالها ");
        } else {
          navigate(`/receiptvoucher/${id}`);
        }
      },
    },
    { label: "تعديل", route: "/editcasedetails/:id" },
  ];

  const handleDownload = (selectedRows) => {
    const selectedData = rows.filter((row) => selectedRows.includes(row.id));
    if (selectedData.length === 0) {
      alert("Please select at least one row.");
      return;
    }

    const csvHeader = columns
      .filter((col) => col.key !== "actions")
      .map((col) => col.name)
      .join(",");

    const csvRows = selectedData.map((row) =>
      columns
        .filter((col) => col.key !== "actions")
        .map((col) => `"${row[col.key] || ""}"`)
        .join(",")
    );

    const csvContent = `${csvHeader}\n${csvRows.join("\n")}`;

    const bom = "\uFEFF";
    const finalContent = bom + csvContent;

    const blob = new Blob([finalContent], { type: "text/csv;charset=utf-8;" });
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.setAttribute("href", url);
    link.setAttribute("download", "selected_rows_report.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const modifyRow = (row) => {
    let newRow = { ...row };
    newRow.total = new Intl.NumberFormat().format(row.total) + " ريال";
    newRow.amount = new Intl.NumberFormat().format(row.amount) + " ريال";

    if (newRow.status === 0) {
      newRow.status =
        '<span  style="border-radius:5px; border:1px solid red; padding:2px ">غير مكتمل</span>';
    } else {
      newRow.status =
        '<span style="border-radius:5px; border:1px solid green; padding:2px ">مكتمل</span>';
    }
    if (newRow.marketingmethod === 1) {
      newRow.marketingmethod = '<span class="rounded p-1">المانحين</span>';
    } else if (newRow.marketingmethod === 2) {
      newRow.marketingmethod =
        '<span class="rounded p-1">المنصات الحكومية</span>';
    } else if (newRow.marketingmethod === 3) {
      newRow.marketingmethod =
        '<span class="rounded p-1">متاجر الجمعيات</span>';
    } else {
      newRow.marketingmethod = '<span class="rounded p-1">غير معرف</span>';
    }
    return newRow;
  };

  return (
    <>
      <div className="printcasedata-container">
        <TableComponent
          apiUrl="/shop"
          columns={columns}
          title="تقرير الحالات"
          titleIcon={<FontAwesomeIcon icon={faWarning} />}
          dropdownOptions={dropdownOptions}
          transformRowFn={modifyRow}
        />
      </div>
    </>
  );
}

export default CaseDetails;
